import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { DashboardDocumentService } from "../../Services/DashboardDocumentService";
import { LookupService } from "../../Services/LookupService";
import { InitialIEPInfoService } from "../../Services/InitialIEPInfoService";
import { IDashboardDocument } from '../../Models/IDashboardDocument';
import { IIepInstance } from '../../Models/IIepInstance';
import { IAdminPlacement } from '../../Models/IAdminPlacement';
import { IInitialIEPInfo } from '../../Models/IInitialIEPInfo';
import { IDueDates } from '../../Models/IDueDates';
import { ICALPADSMeetingDelay } from '../../Models/ICALPADSMeetingDelay';
import { CALPADSMeetingTypeEnum } from '../../Models/Enums/CALPADSMeetingTypeEnum';


import { Globals } from '../../globals'
//import { forEach } from '@angular/router/src/utils/collection';
import { Message } from 'primeng/primeng';
//import { Date } from 'core-js';

@Component({
  selector: 'DocumentDashboard',
  templateUrl: './DocumentDashboard.component.html',
})
export class DocumentDashboardComponent implements OnInit {
  _myGlobals: Globals;
  _dashboardDocumentService: DashboardDocumentService;
  _initialIEPInfoService: InitialIEPInfoService;
  _lookupService: LookupService;
  _baseUrl: string = "";

  _partBInitialMeetingDelayArray: ICALPADSMeetingDelay[];
  //_partCInitialMeetingDelayArray: ICALPADSMeetingDelay[];
  _annualMeetingDelayArray: ICALPADSMeetingDelay[];
  _pendingMeetingDelayArray: ICALPADSMeetingDelay[];
  _triennialMeetingDelayArray: ICALPADSMeetingDelay[];

  _selectedMeetingDelay: ICALPADSMeetingDelay;

  _selectedMeetingId: number;
  errorMessages: any[] = [];
  dashboardDocumentResults: IDashboardDocument[];
  _adminPlacement: IAdminPlacement;
  _iepInstance: IIepInstance;
  _initialIEPInfo: IInitialIEPInfo;
  messages: Message[];
  dueDates: IDueDates;
  disableAddButtons: boolean = false;
  minimumDate: Date;
  maximumDate: Date;
  minimumAPDate: Date;
  maximumAPDate: Date;
  minimumAddendumDate: Date;
  maximumAddendumDate: Date;
  addendumDate: Date;
  iepDate: Date;
  apDate: Date;
  showSpinner: boolean = false;
  isInitialIEPInfoValidForSPED: boolean = false;
  isInitialIEPInfoValidForInitial: boolean = false;
  isConsentProvided: boolean = false;
  isNotSpecialEd: boolean = false;
  todayPlus90: Date;
  consentDatePlus90: Date;

  constructor(
    globals: Globals,
    @Inject('BASE_URL') baseUrl: string,
    dashboardDocumentService: DashboardDocumentService,
    lookupService: LookupService,
    initialIEPInfoService: InitialIEPInfoService
  )
  {
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this._dashboardDocumentService = dashboardDocumentService;
    this._lookupService = lookupService;
    this._initialIEPInfoService = initialIEPInfoService;
  }

  ngOnInit(): void {
    this.minimumDate = new Date();
    this.maximumDate = new Date();
    this.todayPlus90 = new Date();
    this.minimumAPDate = new Date();
    this.maximumAPDate = new Date();
    this.minimumAddendumDate = new Date();
    this.maximumAddendumDate = new Date();
    this.maximumAddendumDate.setDate(this.minimumAddendumDate.getDate() + 29);
    this.addendumDate = null;
    this.iepDate = null;
    this.apDate = null;
    this.maximumDate.setDate(this.minimumDate.getDate() - 1);
    this.todayPlus90.setDate(this.minimumDate.getDate() + 90);

    this._selectedMeetingId = 0;
    this.populateLookupTables();

    this._initialIEPInfoService.getInitialIEPInfo(this._myGlobals.selectedStudent.localStudentId).subscribe((res: IInitialIEPInfo) => {
      this._initialIEPInfo = res as IInitialIEPInfo;

      this.isInitialIEPInfoValidForInitial = false;
      this.isInitialIEPInfoValidForSPED = false;

      if (this._initialIEPInfo != null) {
        if (this._initialIEPInfo.identifiedAsSPEDDate != null
          && this._initialIEPInfo.spedIdentifierDescription != null
          && this._initialIEPInfo.initialIepDate == null
          && this._initialIEPInfo.initialEvalDate == null) {
          this.isInitialIEPInfoValidForInitial = true;
          this.isNotSpecialEd = true;
          this.minimumDate = new Date();
          this.maximumDate.setDate(this.minimumDate.getDate() + 59);
        }
        else if (
          this._initialIEPInfo.identifiedAsSPEDDate == null ||
          this._initialIEPInfo.initialConsentDate == null ||
          this._initialIEPInfo.spedIdentifierDescription == null ||
          this._initialIEPInfo.initialEvalDate == null ||
          this._initialIEPInfo.initialIepDate == null ||
          this._initialIEPInfo.lastEvalDate == null ||
          this._initialIEPInfo.spedEntryDate == null) {
          this.isInitialIEPInfoValidForSPED = false;
        }
        else {
          this.isInitialIEPInfoValidForSPED = true;
        }
        console.log(`after initial iep: isInitialIepInfoValidForSped: `)
      }
    },
      err => console.error(err)
    );

    if (this._myGlobals.selectedStudent.spedStatus == 'N'
      || this._myGlobals.selectedStudent.spedStatus == 'R'
      || this._myGlobals.selectedStudent.spedStatus == 'XX') {
      this.isNotSpecialEd = true;

      this.minimumDate = new Date();
      this.maximumDate = new Date();
      this.maximumDate.setDate(this.minimumDate.getDate() + 59);
    } else if ( this._myGlobals.selectedStudent.spedStatus == 'Y'  
                && this._myGlobals.currentOfficialDocumentIsIEP
                && this._myGlobals.isAddendumInProgress == false ) {
      this.isInitialIEPInfoValidForSPED = true;
      this.isNotSpecialEd = false;
    }

    this._dashboardDocumentService.getDueDates(this._myGlobals.selectedStudent.localStudentId).subscribe((res: IDueDates) => {
      this.dueDates = res as IDueDates;
    },
      err => console.error(err)
    );

  }

  populateLookupTables() {
    // PartBInitial
    this._lookupService.getCALPADSMeetingDelayList(CALPADSMeetingTypeEnum[CALPADSMeetingTypeEnum.PartBInitial]).subscribe((res: ICALPADSMeetingDelay[]) => {
      this._partBInitialMeetingDelayArray = [{ id: null, text: "[Select One]", shortText: "[Select One]", is10PartBInitial: null, is15PartCInitial: null, is20AnnualIEP: null, is30Pending: null, is40TriennialEvaluationIep: null}].concat(res) as ICALPADSMeetingDelay[];
    },
      err => console.error(err)
    );

    //// PartCInitial
    //this._lookupService.getCALPADSMeetingDelayList(CALPADSMeetingTypeEnum[CALPADSMeetingTypeEnum.PartCInitial]).subscribe((res: ICALPADSMeetingDelay[]) => {
    //  this._partCInitialMeetingDelayArray = [{ id: null, text: "[Select One]", shortText: "[Select One]", is10PartBInitial: null, is15PartCInitial: null, is20AnnualIEP: null, is30Pending: null, is40TriennialEvaluationIep: null }].concat(res) as ICALPADSMeetingDelay[];
    //},
    //  err => console.error(err)
    //);

    // AnnualIEP
    this._lookupService.getCALPADSMeetingDelayList(CALPADSMeetingTypeEnum[CALPADSMeetingTypeEnum.AnnualIEP]).subscribe((res: ICALPADSMeetingDelay[]) => {
      this._annualMeetingDelayArray = [{ id: null, text: "[Select One]", shortText: "[Select One]", is10PartBInitial: null, is15PartCInitial: null, is20AnnualIEP: null, is30Pending: null, is40TriennialEvaluationIep: null }].concat(res) as ICALPADSMeetingDelay[];
    },
      err => console.error(err)
    );

    // Pending
    this._lookupService.getCALPADSMeetingDelayList(CALPADSMeetingTypeEnum[CALPADSMeetingTypeEnum.Pending]).subscribe((res: ICALPADSMeetingDelay[]) => {
      this._pendingMeetingDelayArray = [{ id: null, text: "[Select One]", shortText: "[Select One]", is10PartBInitial: null, is15PartCInitial: null, is20AnnualIEP: null, is30Pending: null, is40TriennialEvaluationIep: null }].concat(res) as ICALPADSMeetingDelay[];
    },
      err => console.error(err)
    );

    // TriennialEvaluationIep
    this._lookupService.getCALPADSMeetingDelayList(CALPADSMeetingTypeEnum[CALPADSMeetingTypeEnum.TriennialEvaluationIep]).subscribe((res: ICALPADSMeetingDelay[]) => {
      this._triennialMeetingDelayArray= [{ id: null, text: "[Select One]", shortText: "[Select One]", is10PartBInitial: null, is15PartCInitial: null, is20AnnualIEP: null, is30Pending: null, is40TriennialEvaluationIep: null }].concat(res) as ICALPADSMeetingDelay[];
    },
      err => console.error(err)
    );
  }

  addMessage(msg: Message) {
    if (!this.messages)
      this.messages = [];
    this.messages = [...this.messages, msg];
  }

  clearMessages() {
    this.messages = [];
  }

  documentSelected(selecedDocument: IDashboardDocument) {
    this._myGlobals.documentSelected(selecedDocument);
  }

  createInitialIEP() {
    this.clearMessages();
    let documentTypeLabel = 'Initial'
    let conflictingDraftIep = this._myGlobals.dashboardDocumentResults.find(doc => (doc.status === "Draft") && doc.documentType === documentTypeLabel);

    if (conflictingDraftIep) {
      let conflictMessage: Message = {
        severity: 'error',
        summary: 'Duplicate Draft IEP',
        detail: `There is already a draft ${documentTypeLabel} IEP.`
      }
      this.addMessage(conflictMessage);
      return;
    }
    this.showSpinner = true;
    this.disableAddButtons = true;
    this.clearMessages();

    let meetingDelayCode = null;

    if (this._selectedMeetingDelay != null) {
      meetingDelayCode = this._selectedMeetingDelay.id.toString();
    }

    this._dashboardDocumentService.createNewIEP(this._myGlobals.selectedStudent.localStudentId, 1, this.iepDate, meetingDelayCode).subscribe((res: IIepInstance) => {
      this._iepInstance = res
        , console.log(this._myGlobals.canAddDocuments)
      let successMessage: Message = { severity: 'success', summary: 'New Initial IEP Record Saved Successfully', detail: res.id.toString() }
      this.addMessage(successMessage);
      this._myGlobals.setSelectedStudent(this._myGlobals.selectedStudent);
      this.showSpinner = false;
      this.disableAddButtons = false;
    },
      err => {
        console.error(err);
        let errorMessage: Message = { severity: 'error', summary: 'New Initial IEP Save Failed', detail: err };
        this.addMessage(errorMessage);
        this.showSpinner = false;
        this.disableAddButtons = false;
      }
    );
  }

  createNewIEP() {
    this.clearMessages();
    let documentTypeLabel = this._myGlobals.allowedMeetingTypes.find(mt => mt.value === this._selectedMeetingId.toString()).label;
    let conflictingDraftIep = this._myGlobals.dashboardDocumentResults.find(doc => (doc.status === "Draft") && doc.documentType === documentTypeLabel);

    if (conflictingDraftIep) {
      let conflictMessage: Message = {
        severity: 'error',
        summary: 'Duplicate Draft IEP',
        detail: `There is already a draft ${documentTypeLabel} IEP.`
      }
      this.addMessage(conflictMessage);
      return;
    }
    this.showSpinner = true;
    this.disableAddButtons = true;

    let meetingDelayCode = '';

    if (this._selectedMeetingDelay != null) {
      meetingDelayCode = this._selectedMeetingDelay.id.toString();
    }

    this._dashboardDocumentService.createNewIEP(this._myGlobals.selectedStudent.localStudentId, this._selectedMeetingId, this.iepDate, meetingDelayCode).subscribe((res: IIepInstance) => {
      this._iepInstance = res
        , console.log(this._myGlobals.canAddDocuments)
      let successMessage: Message = { severity: 'success', summary: 'New IEP Record Saved Successfully', detail: res.id.toString() }
      this.addMessage(successMessage);
      this._myGlobals.setSelectedStudent(this._myGlobals.selectedStudent);
      this.showSpinner = false;
      this.disableAddButtons = false;
    },
      err => {
        console.error(err);
        let errorMessage: Message = { severity: 'error', summary: 'New IEP Save Failed', detail: err };
        this.addMessage(errorMessage);
        this.showSpinner = false;
        this.disableAddButtons = false;
      }
    );
  }

  createNewAddendum() {
    this.clearMessages();
    this.showSpinner = true;
    this.disableAddButtons = true;

    this._dashboardDocumentService.createNewAddendum(this._myGlobals.selectedStudent.localStudentId, this.addendumDate).subscribe((res: IIepInstance) => {
      this._iepInstance = res
        , console.log(this._myGlobals.canAddDocuments)
      let successMessage: Message = { severity: 'success', summary: 'New Addendum Record Saved Successfully', detail: res.id.toString() }
      this.addMessage(successMessage);
      this._myGlobals.setSelectedStudent(this._myGlobals.selectedStudent);
      this.showSpinner = false;
      this.disableAddButtons = false;
    },
      err => {
        console.error(err);
        let errorMessage: Message = { severity: 'error', summary: 'New Addendum Save Failed', detail: err };
        this.addMessage(errorMessage);
        this.showSpinner = false;
        this.disableAddButtons = false;
      }
    );
  }

  createNewAP() {
    this.showSpinner = true;
    this.disableAddButtons = true;
    this.clearMessages();
    this._myGlobals.adminPlacementIsVisible = false;
    this._dashboardDocumentService.createNewAP(this._myGlobals.selectedStudent.localStudentId, this.apDate).subscribe((res: IAdminPlacement) => {
      this._adminPlacement = res
        , console.log(this._myGlobals.canAddDocuments)
      let successMessage: Message = { severity: 'success', summary: 'New Admin Placement Record Saved Successfully', detail: res.id.toString() }
      this.addMessage(successMessage);
      this._myGlobals.setSelectedStudent(this._myGlobals.selectedStudent);
      this.apDate = null;
      this.showSpinner = false;
      this.disableAddButtons = false;
    },
      err => {
        console.error(err);
        let errorMessage: Message = { severity: 'error', summary: 'New Admin Placement Save Failed', detail: err };
        this.addMessage(errorMessage);
        this.showSpinner = false;
        this.disableAddButtons = false;

        //as a stopgap There are some situation when APs are being created but the demographic data is not
        //reload data even if there is an error
        this._myGlobals.setSelectedStudent(this._myGlobals.selectedStudent);
      }
    );
  }

  changeMeetingType(eventData) {
    this.maximumDate = new Date();
    this.iepDate = null;
    switch (eventData.value) {
      case '2': //Annual
        this.maximumDate = new Date(this.dueDates.annualDueDate);
        if (this.maximumDate < this.minimumDate) {
          this.maximumDate = new Date(this.todayPlus90);
        }
        break;
      case '3': //Triennial
        this.maximumDate = new Date(this.dueDates.triAnnualDueDate);
        if (this.maximumDate < this.minimumDate) {
          this.maximumDate = new Date(this.todayPlus90);
        }
        break;
      case '6': // 30 Day
        this.maximumDate.setDate(this.minimumDate.getDate() + 29);
        break;
    }
  }

  initialDelaySelected(eventData) {
    this.maximumDate = this.todayPlus90;
    alert('You can now select a meeting date for the new Initial IEP.');
  }

  annualDelaySelected(eventData) {
    this.maximumDate = this.todayPlus90;
    alert('You can now select a meeting date for the new Annual IEP.');
  }

  triennialDelaySelected(eventData) {
    this.maximumDate = this.todayPlus90;
    alert('You can now select a meeting date for the new Triennial IEP.');
  }

}


